module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"PENDING":"Pending agreements","POLICY_ENDING":"Ending insurance policies"},"et":{"PENDING":"Pending agreements","POLICY_ENDING":"Ending insurance policies"},"ru":{"PENDING":"Pending agreements","POLICY_ENDING":"Ending insurance policies"}}')
  delete Component.options._Ctor
}
